import React, { Component } from "react"
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async';
import {
	Container,
	Button,
	Col,
	Card,
	CardBody,
	CardTitle,
	Spinner,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Link } from "react-router-dom"
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../components/Common/withRouter"
import PlacementEditForm from "./PlacementEditForm";

// Utilities
import {
	createNotificationHelpers,
	updatePlacement,
	updateTotalFees,
	updateStoreSettings,
	fetchMerchantInfo,
} from "../utils";

class PlacementEdit extends Component {
	constructor(props) {
		super(props)
		this.state = {
			shop: "",
			value: 60,
			loading: true,
			store_details: {},
			store_status: "",
			field: "",
			jsonError: "",
		}

		// Initialize notification helpers
		const notifications = createNotificationHelpers();
		this.notify_error = notifications.notify_error;
		this.notify_success = notifications.notify_success;
	}
	componentDidMount() {
		const locationState = this.props.location?.state;
		const data = locationState?.data || this.props.location?.data;
		const params = new URLSearchParams(this.props.location?.search || '');

		// Extract field from query parameter first (more reliable), then from state data
		const fieldFromQuery = params.get('field');
		const fieldFromData = data?.field;
		const field = fieldFromQuery || fieldFromData || '';

		if (data && data.store_domain) {
			const { store_domain, value, store_details, store_status } = data;

			// Handle cart_location - it might be a string or already an object
			let fieldValue = value;
			if (field === 'cart_location') {
				if (typeof value === 'string') {
					try {
						fieldValue = value ? JSON.parse(value) : {};
					} catch (e) {
						fieldValue = {};
					}
				} else {
					fieldValue = value || {};
				}
			}

			this.setState({
				shop: store_domain,
				value: fieldValue,
				store_details: { ...store_details },
				store_status,
				field: field || data.field || '', // Ensure field is set
				loading: false
			});
			return;
		}

		// Handle query parameter access (state was lost - common on refresh)
		const store = params.get('store');
		if (store && field) {
			this.setState({
				shop: store,
				field: field,
				loading: true
			});
			// Fetch merchant data to get the current field value
			this.loadMerchantData(store, field);
		} else if (store) {
			this.setState({
				shop: store,
				loading: false
			});
		}
	}

	/**
	 * Loads merchant data from API and extracts field value
	 */
	loadMerchantData = async (storeDomain, field) => {
		const merchantData = await fetchMerchantInfo(storeDomain, this.notify_error);

		if (merchantData) {
			const store_details = merchantData.store_details || merchantData;
			const store_status = merchantData.store_status || "";

			// Extract the field value based on field type
			let fieldValue = '';
			if (field === 'cart_location') {
				try {
					fieldValue = store_details.cart_location ?
						(typeof store_details.cart_location === 'string'
							? JSON.parse(store_details.cart_location)
							: store_details.cart_location)
						: {};
				} catch (e) {
					fieldValue = {};
				}
			} else if (field === 'public_access_token') {
				fieldValue = store_details.public_access_token || '';
			} else if (field === 'placement') {
				fieldValue = store_details.placement || '';
			} else if (field === 'total_fees') {
				fieldValue = store_details.total_fees || 0;
			} else {
				// For other fields, try to get from store_details
				fieldValue = store_details[field] || '';
			}

			this.setState({
				shop: storeDomain,
				value: fieldValue,
				store_details: { ...store_details },
				store_status,
				field,
				loading: false
			});
		} else {
			this.setState({ loading: false });
		}
	}
	/**
	 * Handles form submission
	 */
	handleValidSubmit = async (e) => {
		e.preventDefault();
		// this.setState({ loading: true });
		const { shop, value, field, store_details } = this.state;

		let success = false;

		if (field === 'placement') {
			success = await updatePlacement(shop, value, this.notify_error);
		} else if (field === 'total_fees') {
			success = await updateTotalFees(shop, value, this.notify_error);
		} else {
			// For other fields like public_access_token, cart_location
			success = await updateStoreSettings(shop, store_details.id, field, value, this.notify_error);
		}

		if (success) {
			// this.setState({ loading: false });
			this.notify_success(`${field} has been updated successfully!`);
		}
	}
	handleJsonError = (error) => {
		this.setState({
			...this.state,
			jsonError: error
		})
	}
	handleInputChange = (e) => {
		this.setState({
			[e.target.name]: e.target.value
		})
	}
	handleJsonChange = (jsonData) => {
		// Handle the JSON data changes here
		try {
			const parsedJson = JSON.parse(jsonData);
			this.setState({
				...this.state,
				value: parsedJson,
				jsonError: ''
			})

		} catch (error) {
			this.setState({
				...this.state,
				jsonError: 'Error parsing JSON. Please check the JSON syntax and try again.'
			})
		}
	};


	render() {
		const { shop, value, field, loading, store_details, store_status, jsonError } = this.state;
		return (
			<React.Fragment>
				<div className="page-content">
					<Helmet>
						<title>Veeper | AP - Placement Edit</title>
					</Helmet>
					<Container fluid>
						<Breadcrumbs
							title={(`${field}`)}
							breadcrumbItem={("Edit")}
						/>
						<ToastContainer />
						<Col md={12}>
							<Card>
								<CardBody>
									<CardTitle className="h4"></CardTitle>
									{(() => {
										const backData = (store_details && Object.keys(store_details).length > 0) ? store_details : { store_domain: shop };
										return (
											<Link to={{ pathname: "/merchant-details", search: shop ? `?store=${encodeURIComponent(shop)}` : undefined, state: { data: backData, storeStatus: store_status } }} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>

												<Button className="btn btn-dark">
													<i className="fa fa-arrow-left"></i> Store Details
												</Button>
											</Link>
										);
									})()}

									{loading ? (
										<div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
											<Spinner color="primary" />
										</div>
									) : (
										<PlacementEditForm
											shop={shop}
											value={value}
											field={field}
											jsonError={jsonError}
											onInputChange={this.handleInputChange}
											onJsonChange={this.handleJsonChange}
											onSubmit={this.handleValidSubmit}
										/>
									)}
								</CardBody>
							</Card>
						</Col>

					</Container>
				</div>
			</React.Fragment>
		)
	}
}

PlacementEdit.propTypes = {
	t: PropTypes.any
}
export default withRouter(PlacementEdit)
